import { Button, createStyles, Grid, withStyles } from '@material-ui/core';
import React from 'react';
const styledBy = (property, mapping) => (props) => mapping[props[property]];
export const TpButton = withStyles((theme) => createStyles({
    root: {
        color: styledBy('color', {
            default: theme.palette.getContrastText(theme.palette.secondary.main),
            primary: theme.palette.primary.main,
            secondary: theme.palette.secondary.main,
        })
    }
}))(Button);
//export function TpRadioButton<TValue>({ options, value, onChange, color, gridProps }: TpRadioButtonProps<TValue> & { gridProps: GridProps }) {
export function TpRadioButton({ options, value, onChange, color, spacing, xs, sm, md, lg, xl, direction }) {
    return (React.createElement(Grid, { container: true, spacing: spacing, direction: direction }, options.map((o, i) => (React.createElement(Grid, { item: true, xs: xs || 'auto', sm: sm, md: md, lg: lg, xl: xl, key: i },
        React.createElement(Button, { startIcon: o.icon, classes: { root: `tp-flight-selector${o.value == value ? ' selected' : ''}` }, variant: o.value == value ? 'outlined' : 'outlined' || 'text', onClick: e => onChange(o.value) }, o.name))))));
}
